import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function LngCargoCompressorTable({ data, onEdit }) {
  const columns = [
    {
      title: "LNG Cargo Compressor Name",
      dataIndex: "lng_name",
      key: "lng_name",
      align: "center",
    },
    {
      title: "LNG Cargo Compressor Maker",
      dataIndex: "lng_maker",
      key: "lng_maker",
      align: "center",
    },
    {
      title: "LNG Cargo Compressor Model",
      dataIndex: "lng_model",
      key: "lng_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
